import { tamarackAPI, processApiResponse } from "./Tamarack";

export const BrokerDataAPI = {
    async getAllBroker(Offset) {
		const path = `brokers?Offset=${Offset}`;
        tamarackAPI.setHeader("broker-id", "ALL");
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

    async getBrokerById(brokerId, headerBrokerId) {
        const path = `broker/${brokerId}`;
        tamarackAPI.setHeader("broker-id", headerBrokerId);
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },

};
